import {
  FrontSide,
  MeshStandardMaterial,
  type MeshStandardMaterialParameters,
} from "three";

// Chrome-plated steel (rivets): the shiniest thing on a case, and deliberately
// a different family from both the aluminium extrusions and the matte sheet
// metal around it — a plated fastener is what it is regardless of what it is
// driven into.
//
// `color` is a tinted grey rather than white: chromium reflects a little less
// than aluminium and slightly cooler, so a lighter colour here would make the
// rivets read as aluminium beads instead of hardware. Since `metalness` is 1
// this is the reflectance tint only — there is no diffuse term for it to
// lighten.
//
// `roughness` is far below what AluminumMaterial warns about (a smooth metal
// mirroring a 1k environment map reads as noise rather than as polish). That
// warning is about large flat faces; a rivet is a 4 mm dome, and a convex
// surface that small compresses the whole environment into a few pixels, so a
// near-mirror finish resolves as one compact highlight. Which is exactly what
// picks the rivets out of the extrusion they sit in.
//
// Single source of truth for both the raw material and the JSX component.
export const CHROME_MATERIAL_PARAMS: MeshStandardMaterialParameters = {
  color: "#d8dde3",
  metalness: 1,
  roughness: 0.08,
  // Unlike the aluminium and sheet-metal materials, which cover open shells
  // and single-sided imports: a rivet is a closed sphere, so its back faces
  // are never visible and rasterising them only costs fragments — and feeds
  // flipped normals to the ambient occlusion pass.
  side: FrontSide,
};

export const getRawChromeMaterial = () =>
  new MeshStandardMaterial(CHROME_MATERIAL_PARAMS);

export const ChromeMaterial = () => (
  <meshStandardMaterial {...CHROME_MATERIAL_PARAMS} />
);
